import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { LotesConferenciaComponent } from './lotes-conferencia.component';

@NgModule({
  declarations: [LotesConferenciaComponent],
  imports: [CommonModule, FormsModule, NgSelectModule],
  exports: [LotesConferenciaComponent]
})
export class LotesConferenciaModule {}

